function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { performerRetrieve } from "../dmp-utils";
import AbstractDmpParser from "./abstract-dmp-parser";
export default class MedicalActDmpParser extends AbstractDmpParser {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "journalEventClassName", "MedicalActRefundedJournalEvent");
  }
  canParse(section) {
    const code = section.code?._attributes?.code;
    const title = section.title?._text;
    return code == "29554-3" && title == "Soins médicaux et dentaires";
  }
  parse(section) {
    return this.getEntries(section).map(entry => {
      const procedure = entry.procedure;
      if (!procedure) return;
      const source = procedure?.code?._attributes;
      if (source.nullFlavor || source.codeSystem == "1.2.250.1.213.2.63") return;
      const occurredAt = this.parseOccurredAt(procedure);
      if (!occurredAt) return;
      let procedureSourceConcept;
      if (source.codeSystem == "1.2.250.1.215.200.3.3") {
        procedureSourceConcept = "NGAP";
      } else if (source.codeSystem == "1.2.250.1.215.200.3.4") {
        procedureSourceConcept = "CCAM";
      } else {
        return;
      }
      const procedureSourceValue = source.code;
      const procedureSourceLabel = source.displayName;
      const performer = procedure?.performer?.assignedEntity;
      if (!performer) return;
      if (occurredAt && procedureSourceConcept && procedureSourceValue && procedureSourceLabel) {
        return {
          occurredAt,
          procedureSourceConcept,
          procedureSourceValue,
          procedureSourceLabel,
          performer: performerRetrieve(entry.procedure?.performer)
        };
      }
      return undefined;
    }).filter(Boolean);
  }
}